import phone from './phone';
import watch from './watch';
import tablet from './tablet';

export default {
    phone,
    watch,
    tablet
};
